import React from 'react';
import './footer.css';
import Logo from '../assets/logo/logo';

const footer = () =>{
   return (
        <div className="footer-container">
            <div style={{float: "left"}}>
                <Logo />
            </div>  
           <div className="footer-description">
               <p>&copy; 2020, Online Learning Platform Developed by Karabet Jazmahji </p>
           </div>  
        </div>  
   )
}

export default footer;